var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isBrowser } from '../../lib/environment';
import { log } from '../../lib/logger';
import { captureException } from '../../lib/sentry';
import { Option } from 'effect';
import { getTokenProvider } from './TokenProvider';
export const getToken = (clientId, scopes = []) => __awaiter(void 0, void 0, void 0, function* () {
    if (!isBrowser)
        return new Promise(() => { });
    try {
        const token = yield getTokenProvider(clientId, scopes).getNewToken();
        return Option.some(token);
    }
    catch (e) {
        if (e.error === 'login_required' || e.error === 'timeout') {
            return Option.none();
        }
        log.error('There was an error on login', e);
        captureException(e);
        throw e;
    }
});
export const login = (clientId, redirectUri) => {
    if (!isBrowser)
        return;
    getTokenProvider(clientId, []).gotoLoginWindow(redirectUri);
};
